import { useState } from "react";
import MainNavbar from "../../MainNavbar";
import ProfileSummary from "./ProfileSummary";
import ProfileQuality from "./ProfileQuality";
import api from "../../../../utils/api";
import "./ProfileAI.css";

export default function ProfileAIToolsPage() {
  const [bio, setBio] = useState("");
  const [summary, setSummary] = useState("");
  const [quality, setQuality] = useState(null);
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [loadingQuality, setLoadingQuality] = useState(false);

  const generateSummary = async () => {
    if (!bio) return alert("Enter your bio first!");

    setLoadingSummary(true);
    try {
      const data = await api.profileSummary(bio);
      setSummary(data.summary);
    } catch {
      alert("Summary generation failed");
    }
    setLoadingSummary(false);
  };

  const checkQuality = async () => {
    if (!bio) return alert("Enter your bio first!");

    setLoadingQuality(true);
    try {
      const data = await api.profileQuality(bio);
      setQuality(data.quality);
    } catch {
      alert("Quality check failed");
    }
    setLoadingQuality(false);
  };

  return (
    <div className="ai-page-container">
      <MainNavbar />

      <div className="ai-content">
        <h2 className="ai-title">✨ AI Profile Tools</h2>

        {/* INPUT SECTION */}
        <div className="ai-input-section">
          <textarea
            placeholder="Write your profile bio here..."
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            className="ai-textarea"
          />

          <div className="ai-button-row">
            <button
              className="ai-button"
              onClick={generateSummary}
              disabled={loadingSummary}
            >
              {loadingSummary ? "Generating..." : "Generate Summary"}
            </button>

            <button
              className="ai-button-outline"
              onClick={checkQuality}
              disabled={loadingQuality}
            >
              {loadingQuality ? "Checking..." : "Check Quality"}
            </button>
          </div>
        </div>

        {/* RESULT SECTION – LEFT & RIGHT */}
        {(summary || quality) && (
          <div className="ai-result-grid">
            {summary && (
              <div className="ai-left-panel">
                <ProfileSummary summary={summary} />
              </div>
            )}

            {quality && (
              <div className="ai-right-panel">
                <ProfileQuality quality={quality} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
